import PropTypes from 'prop-types';
import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import AiChatInput from '../common/search/aiChatInput';
const AiChatModal = _ref => {
  let isOpen = _ref.isOpen,
    onToggle = _ref.onToggle,
    onSendMessage = _ref.onSendMessage,
    onClear = _ref.onClear,
    waitingMessage = _ref.waitingMessage,
    emptyStateMessage = _ref.emptyStateMessage,
    _ref$messages = _ref.messages,
    messages = _ref$messages === void 0 ? [] : _ref$messages,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? /*#__PURE__*/React.createElement("span", null, "AI Chat Assistant") : _ref$label,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? 'Ask me anything...' : _ref$placeholder,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? '' : _ref$text;
  const handleToggle = () => {
    if (!isLoading) onToggle();
  };
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    toggle: handleToggle,
    size: "xl",
    "data-testid": "t-cf-ai-chat-modal",
    style: {
      maxWidth: '800px'
    },
    backdrop: isLoading ? 'static' : true,
    keyboard: !isLoading
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    toggle: handleToggle
  }, label), /*#__PURE__*/React.createElement(ModalBody, {
    className: "p-0"
  }, /*#__PURE__*/React.createElement(AiChatInput, {
    className: "t-cf-ai-chat",
    messages: messages,
    onSendMessage: onSendMessage,
    onClear: onClear,
    placeholder: placeholder,
    isLoading: isLoading,
    text: text,
    waitingMessage: waitingMessage,
    emptyStateMessage: emptyStateMessage
  })), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
    color: "secondary",
    onClick: handleToggle,
    disabled: isLoading
  }, "Close")));
};
AiChatModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  onSendMessage: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  messages: PropTypes.arrayOf(PropTypes.shape({
    content: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['user', 'assistant', 'system']).isRequired,
    timestamp: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })),
  isLoading: PropTypes.bool,
  label: PropTypes.node,
  placeholder: PropTypes.string,
  text: PropTypes.string,
  waitingMessage: PropTypes.string.isRequired,
  emptyStateMessage: PropTypes.string.isRequired
};
export default AiChatModal;